module.exports = __webpack_public_path__ + "img/product3.73a24409.jpeg";